if (!customElements.get('custom-accordion')) {
  customElements.define(
    'custom-accordion',
    class AccordionElement extends HTMLElement {
      constructor() {
        super();
        // Reference the existing <details> element inside the custom element
        this.el = this.querySelector('details');
        this.summary = this.el.querySelector('summary');
        this.content = this.el.querySelector('.content');
        this.imgContainer = document.querySelector(`.${this.dataset.faqImageClass}`);
        this.itemImageUrl = this.dataset.image;
        this.sectionId = this.dataset.sectionId;

        // Initialize state variables
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;

        // Event listener
        this.summary.addEventListener('click', (e) => this.onClick(e));
      }

      onClick(e) {
        this.closeOtherAccordions();
        e.preventDefault();
        this.el.style.overflow = 'hidden';

        // If animation is ongoing, return to avoid conflicting animations
        if (this.isClosing || this.isExpanding) return;

        // If the element is closed, we expand it, otherwise we shrink it
        if (!this.el.open) {
          
          this.toggleAccordion(true); // Expand
          if (this.imgContainer){
            this.imgContainer.classList.add('item-image-expand');
            this.imgContainer.classList.remove('item-image-shrink');
          }
        } else {
          this.toggleAccordion(false); // Shrink
          if (this.imgContainer){
            this.imgContainer.classList.add('item-image-shrink');
            this.imgContainer.classList.remove('item-image-expand');
          }
        }
      }
      closeOtherAccordions() {
        // Get all accordion elements
        const allAccordions = document.querySelectorAll(`#${this.sectionId} custom-accordion`);
        allAccordions.forEach((accordion) => {
          if (accordion !== this && accordion.el.open) {
            accordion.toggleAccordion(false); // Close it
            if (accordion.imgContainer) {
              accordion.imgContainer.classList.add('item-image-shrink');
              accordion.imgContainer.classList.remove('item-image-expand');
            }
          }
        });
      }
      toggleAccordion(expand) {
        // Set the appropriate state for expanding or shrinking
        if (expand) {
          this.isExpanding = true;
        } else {
          this.isClosing = true;
        }

        // Cache start height
        const startHeight = `${this.el.offsetHeight}px`;

        // If expanding, force the open state to calculate the full height
        if (expand) {
          this.el.open = true;
          if(this.itemImageUrl !== '' && this.imgContainer) {
            this.imgContainer.src = `${this.itemImageUrl}`;
          }
        }

        // Calculate the end height based on expanding or shrinking
        const endHeight = expand
          ? `${this.summary.offsetHeight + this.content.offsetHeight}px`
          : `${this.summary.offsetHeight}px`;

        // If there's an existing animation, cancel it
        if (this.animation) {
          this.animation.cancel();
        }

        // Animate between the start and end height
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 230,
            easing: 'ease-in-out',
          }
        );

        // Handle when the animation finishes
        this.animation.onfinish = () => this.onAnimationFinish(expand);
        this.animation.oncancel = () => {
          this.isClosing = this.isExpanding = false; // Reset states if animation is canceled
        };
      }

      onAnimationFinish(expand) {
        // If shrinking, set `open` to false
        if (!expand) {
          this.el.open = false;
        }

        // Reset the animation and state
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;

        // Clear inline styles to reset the layout
        this.el.style.height = '';
        this.el.style.overflow = '';
      }
    }
  );
}